module.exports = __webpack_public_path__ + "static/media/Thinxtra-Australia-Logo.cd327ba4.png";